import React, { useMemo } from "react"

import {
  DESKTOP_SIZE,
  MOBILE_SIZE,
  MOBILE_SMALL_SIZE,
  TABLET_SIZE,
  useMediaQuery
} from "shared/lib/useMediaQuery"

export interface ScreenSizeContextType {
  isDesktop: boolean
  isTablet: boolean
  isMobile: boolean
  isMobileSmall: boolean
}

export const ScreenSizeContext = React.createContext<ScreenSizeContextType>({
  isDesktop: true,
  isTablet: false,
  isMobile: false,
  isMobileSmall: false
})

export const ScreenSizeContextProvider = React.memo(
  ({ children }: { children: React.ReactNode }) => {
    const isDesktop = useMediaQuery(DESKTOP_SIZE)
    const isTablet = useMediaQuery(TABLET_SIZE)
    const isMobile = useMediaQuery(MOBILE_SIZE)
    const isMobileSmall = useMediaQuery(MOBILE_SMALL_SIZE)

    const value = useMemo(
      () => ({
        isDesktop,
        isTablet,
        isMobile,
        isMobileSmall
      }),
      [isDesktop, isTablet, isMobile, isMobileSmall]
    )

    return (
      <ScreenSizeContext.Provider value={value}>
        {children}
      </ScreenSizeContext.Provider>
    )
  }
)
